import { useState } from "react";

import ModuleChartMultiView from "../../../components/chartMultiView";

import { Button } from "primereact/button";

export default function ModulePopProjectPreview({ prePopOption, closePrePop }) {
  return (
    <>
      <div className="text-center px-3">
        <ModuleChartMultiView mappingURLID={prePopOption.data.mappingURLID} />

        <div className="text-right">
          <div className="w-full mt-3">
            <Button
              className="p-button-secondary px-4"
              type="button"
              label="關閉"
              onClick={() => closePrePop({ type: "preview" })}
            />
          </div>
        </div>
      </div>
    </>
  );
}
